import React from 'react';
import { Calendar } from '../../components';

const CalendarTab = () => {
  return <Calendar />;
};

export default CalendarTab;